import React from "react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { ScrollToTop } from "@/components/layout/ScrollToTop";

export const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-background">
    <ScrollToTop />
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
